//Wheel
import wheel1 from "../assets/wheels/2024 02 16 - photo rota/ATLAS 1/ATLAS 1 17_17x8.5_4_5x139.7_106.1_ RL YMH BLK/plain/DSCF7736 1nobg.webp";
import wheel2 from "../assets/wheels/2024 02 16 - photo rota/CIRCUIT 8/CIRCUIT 8_15x6.5_38_8x100x100_67.1_BRONZE/plain/DSCF7684 nobg.webp";
import wheel3 from "../assets/wheels/2024 02 16 - photo rota/CIRCUIT 10/CIRCUIT 10_15X6.5_45_4X100_67.1_RF SP BRONZE/plain/DSCF7400 3nobg.webp";
import wheel4 from "../assets/wheels/2024 02 16 - photo rota/D2/D2_16x7_40_5x114_73_RL CARBON FIBER/plain/DSCF7895 1nobg.webp";
import wheel5 from "../assets/wheels/2024 02 16 - photo rota/DPT/DPT_17x8_48_10x114x100_73_HYPER BLACK/plain/DSCF7640nobg.webp";
import wheel6 from "../assets/wheels/2024 02 16 - photo rota/FIGHTER/FIGHTER 10H 1670_16X7_40_10X114.3X100_73_HYPER SILVER IMP1/plain/DSCF8177nobg.webp";
import wheel7 from "../assets/wheels/2024 02 16 - photo rota/FIVE STAR OFF/FIVE STAR OFF_16x8_10_6x139.7_110_BRONZE/plain/DSCF7417nobg.webp";
import wheel8 from "../assets/wheels/2024 02 16 - photo rota/G-FORCE/G-FORCE_17x9_42_5x100_73_HYPER BLACK/plain/DSCF7469nobg.webp";
import wheel9 from "../assets/wheels/2024 02 16 - photo rota/GRID CLASSIC/GRID CLASSIC_15x7_0_4x100_67.1_RF SP BRONZE/plain/DSCF7533 6nobg.webp";
import wheel10 from "../assets/wheels/2024 02 16 - photo rota/GRID CLASSIC/GRID CLASSIC_15x7_20_4x100_67.1_BRONZE/plain/DSCF7945nobg.webp";
import wheel11 from "../assets/wheels/2024 02 16 - photo rota/GRID CLASSIC/GRID CLASSIC_15x7_20_4x100_67.1_WHITE/plain/DSCF7835 1nobg.webp";
import wheel12 from "../assets/wheels/2024 02 16 - photo rota/GRID CLASSIC/GRID CLASSIC_15x8_0_4x100_67.1_RF P SILVER/plain/DSCF7748 1nobg.webp";
import wheel13 from "../assets/wheels/2024 02 16 - photo rota/GRID CLASSIC/GRID CLASSIC_15x8_0_5x114_73_FLAT GUN YMH BLK LIP/plain/DSCF7813 1nobg.webp";
import wheel14 from "../assets/wheels/2024 02 16 - photo rota/GRID CLASSIC/GRID CLASSIC_15x9_-15_4x114_73_RF SP BRONZE/plain/DSCF7799 3nobg.webp";
import wheel15 from "../assets/wheels/2024 02 16 - photo rota/GRID CLASSIC/GRID CLASSIC_16x8_20_4x100_67.1_SATIN BLACK/plain/DSCF7956nobg.webp";
import wheel16 from "../assets/wheels/2024 02 16 - photo rota/GRID CLASSIC/GRID CLASSIC_16x8_20_5x114_73_WHITE/plain/DSCF7779 1nobg.webp";

// Concave
import wheel17 from "../assets/wheels/2024 02 16 - photo rota/GRID CONCAVE/GRID CONCAVE_15x8_20_5x114_73_HYPER BLACK/plain/DSCF7793 1nobg.webp";
import wheel18 from "../assets/wheels/2024 02 16 - photo rota/GRID CONCAVE/GRID CONCAVE_15x8_20_5x114_73_WHITE/plain/DSCF7938nobg.webp";
import wheel19 from "../assets/wheels/2024 02 16 - photo rota/GRID CONCAVE/GRID CONCAVE_15X8_20_5X114.3_73_PLAIN SILVER/plain/DSCF8518nobg.webp";
import wheel20 from "../assets/wheels/2024 02 16 - photo rota/GRID CONCAVE/GRID CONCAVE_15X8_20_5X114.3_73_RF P SILVER/plain/DSCF8512nobg.webp";
import wheel21 from "../assets/wheels/2024 02 16 - photo rota/GRID CONCAVE/GRID CONCAVE_15X8_20_5X114.3_73_RF SP BRONZE/plain/DSCF8475nobg.webp";
import wheel22 from "../assets/wheels/2024 02 16 - photo rota/GRID CONCAVE/GRID CONCAVE_15x9_36_4x100_67.1_HYPER BLACK/plain/DSCF7588nobg.webp";
import wheel23 from "../assets/wheels/2024 02 16 - photo rota/GRID CONCAVE/GRID CONCAVE_15x9_36_4x100_67.1_SPEED BRONZE/plain/DSCF7502nobg.webp";
import wheel24 from "../assets/wheels/2024 02 16 - photo rota/GRID CONCAVE/GRID CONCAVE_16X8_20_5X114.3_73_RF P SILVER/plain/DSCF8497nobg.webp";
import wheel25 from "../assets/wheels/2024 02 16 - photo rota/GRID CONCAVE/GRID CONCAVE_16X8_20_5X114.3_73_SATIN BLACK/plain/DSCF8489nobg.webp";
import wheel26 from "../assets/wheels/2024 02 16 - photo rota/GRID CONCAVE/GRID CONCAVE_16X8_20_5X114.3_73_WHITE/plain/DSCF8500nobg.webp";

// Racing
import wheel27 from "../assets/wheels/2024 02 16 - photo rota/GRID RACING/GRID RACING_15x6.5_38_4x100_67.1_SPORT BRONZE/plain/DSCF7949nobg.webp";
import wheel28 from "../assets/wheels/2024 02 16 - photo rota/GRID RACING/GRID RACING_15x7_38_4x100_67.1_PCWH_WHITE/plain/DSCF7785 1nobg.webp";
import wheel29 from "../assets/wheels/2024 02 16 - photo rota/GRID RACING/GRID RACING_16x7_42_4x108_63.35_SATIN BLACK/plain/DSCF7820 1nobg.webp";
import wheel30 from "../assets/wheels/2024 02 16 - photo rota/GRID RACING/GRID RACING_17x7.5_45_5x114_73_PCSB_RF SP BRONZE/plain/DSCF7594nobg.webp";
import wheel31 from "../assets/wheels/2024 02 16 - photo rota/GRID RACING/GRID RACING_17x8_40_4x108_73_HYPER BLACK/plain/DSCF7656nobg.webp";
import wheel32 from "../assets/wheels/2024 02 16 - photo rota/GRID RACING/GRID RACING_17x8_40_4x108_73_WHITE/plain/DSCF7695 1nobg.webp";
import wheel33 from "../assets/wheels/2024 02 16 - photo rota/GRID RACING/GRID RACING_17x8_44_5x100_73_PLAIN GOLD/plain/DSCF7829 1nobg.webp";
import wheel34 from "../assets/wheels/2024 02 16 - photo rota/GRID RACING/GRID RACING_17x9_42_5x114_73_SATIN BLACK/plain/DSCF7907nobg.webp";
import wheel35 from "../assets/wheels/2024 02 16 - photo rota/GRID RACING/GRID RACING_18x9.5_20_5x114_73_PLAIN GOLD/plain/DSCF7914nobg.webp";
import wheel36 from "../assets/wheels/2024 02 16 - photo rota/GRID RACING/GRID RACING_18x10_30_5x100_73_FLAT BLACK/plain/DSCF7510nobg.webp";
import wheel37 from "../assets/wheels/2024 02 16 - photo rota/GRID RACING/GRID RACING_19x8.5_44_5x114_73_CHAMELEON/plain/DSCF7478nobg.webp";
import wheel38 from "../assets/wheels/2024 02 16 - photo rota/GRID RACING/GRID RACING_19x8.5_44_5x114_73_SPEED BRONZE/plain/DSCF7520nobg.webp";
import wheel39 from "../assets/wheels/2024 02 16 - photo rota/GRID RACING/GRID RACING_19x9.5_38_5x114_73_TITANIUM CHROME/plain/DSCF7485nobg.webp";
import wheel40 from "../assets/wheels/2024 02 16 - photo rota/GRID RACING/GRID RACING_19X9.5_45_5X120_64.1_COSMIC BLUE/plain/DSCF8436nobg.webp";
import wheel41 from "../assets/wheels/2024 02 16 - photo rota/GRID RACING/GRID RACING_19X9.5_45_5X120_64.1_RF SP BRONZE/plain/DSCF8445nobg.webp";
import wheel42 from "../assets/wheels/2024 02 16 - photo rota/GRID RACING/GRID RACING_19x9.5_45_5X120_64.1_SATIN BLACK/plain/DSCF8452nobg.webp";
import wheel43 from "../assets/wheels/2024 02 16 - photo rota/GRID RACING/GRID RACING_19x10.5_15_5x114_73_FLAT BLACK/plain/DSCF7502nobg.webp";

import wheel44 from "../assets/wheels/2024 02 16 - photo rota/HB10/HB10_15x7_35_4x100_56.1_RL GUNMETALLIC/plain/DSCF7436nobg.webp";
import wheel45 from "../assets/wheels/2024 02 16 - photo rota/HUNTER/HUNTER_15x7_35_4x100_67.1_SPORT BRONZE/plain/DSCF7527nobg.webp";
import wheel46 from "../assets/wheels/2024 02 16 - photo rota/J-SPL/J-SPL_15x6.5_37_4x100_67.1_RL CARBON FIBER/plain/DSCF7902nobg.webp";

import wheel47 from "../assets/wheels/2024 02 16 - photo rota/KB-R/KBR_18X9.5_38_5X100_73_WHITE/plain/DSCF8139nobg.webp";
import wheel48 from "../assets/wheels/2024 02 16 - photo rota/KB-R/KBR_18x9.5_38_5x114_73_SATIN BLACK/plain/DSCF7668nobg.webp";
import wheel49 from "../assets/wheels/2024 02 16 - photo rota/KB-R/KBR_18X9.5_38_5X114.3_73_PLAIN GOLD/plain/DSCF8153nobg.webp";

import wheel50 from "../assets/wheels/2024 02 16 - photo rota/KENSEI/KENSEI_15x9_-15_4x114_73_RL HYP BLK/plain/DSCF7610nobg.webp";

import wheel51 from "../assets/wheels/2024 02 16 - photo rota/MXR/MXR-R2 18_18x11_20_5x114_73_RL HYP BLK/plain/DSCF7495nobg.webp";

import wheel52 from "../assets/wheels/2024 02 16 - photo rota/OS MESH/OS MESH 15_15x8_20_4x100_67.1_RL STEEL GRAY/plain/DSCF7625nobg.webp";

import wheel53 from "../assets/wheels/2024 02 16 - photo rota/PSD/PSD 17_17x7.5_35_5x130_71.6_FSL FSB FBI/plain/DSCF7881 1nobg.webp";
import wheel54 from "../assets/wheels/2024 02 16 - photo rota/PSD/PSD 17_17x7.5_35_5x130_71.6_RL YMH BLACK/plain/DSCF7721nobg.webp";
import wheel55 from "../assets/wheels/2024 02 16 - photo rota/PSD/PSD 17_17x9_16_5x130_71.6_FSL FSB FBI/plain/DSCF7715 1nobg.webp";
import wheel56 from "../assets/wheels/2024 02 16 - photo rota/PSD/PSD 17_17x11_16_5x130_71.6_FSL FSP FBI/plain/DSCF7706nobg.webp";
import wheel57 from "../assets/wheels/2024 02 16 - photo rota/PSD/PSD 17_17x11_16_5x130_71.6_RL YMH BLK/plain/DSCF7700nobg.webp";

import wheel58 from "../assets/wheels/2024 02 16 - photo rota/R-SPEC/R-SPEC 16_16x7_45_4x100_67.1_SATIN BLACK/plain/DSCF7762 1nobg.webp";

import wheel59 from "../assets/wheels/2024 02 16 - photo rota/RB/RB 15_15x7_4_4x114_73_RL P SILVER/plain/DSCF7560nobg.webp";
import wheel60 from "../assets/wheels/2024 02 16 - photo rota/RB/RB 15_15X7_4_4X114.3_73_SATIN BLACK/plain/DSCF8483nobg.webp";
import wheel61 from "../assets/wheels/2024 02 16 - photo rota/RB/RB 15_15x7_12_4x114_73_RL P SILVER/plain/DSCF7552nobg.webp";
import wheel62 from "../assets/wheels/2024 02 16 - photo rota/RB/RB 16_16X7_40_4X100_56.1_RL GUNMETALLIC/plain/DSCF7757 2nobg.webp";
import wheel63 from "../assets/wheels/2024 02 16 - photo rota/RB/RB 17_17X7.5_45_4X100_56.1_RL P SILVER/plain/DSCF7926 1nobg.webp";
import wheel64 from "../assets/wheels/2024 02 16 - photo rota/RB/RB REAR 17_17X8.5_4_4X114.3_73_RL HYP BLACK/plain/DSCF7645nobg.webp";
import wheel65 from "../assets/wheels/2024 02 16 - photo rota/RB/RB_13x8_4_4x114_73_RL P SILVER/plain/DSCF7690nobg.webp";
import wheel66 from "../assets/wheels/2024 02 16 - photo rota/RB/RB-X 17_17X9_-13_4X114.3_73_RL GUNMETALLIC/plain/DSCF7855 2nobg.webp";
import wheel67 from "../assets/wheels/2024 02 16 - photo rota/RB/RB-X 17_17X9_-13_4X114.3_73_RL HYP BLACK/plain/DSCF7867 1.webp";
import wheel68 from "../assets/wheels/2024 02 16 - photo rota/RB/RB-X 17_17X9_-13_4X114.3_73_RL YMH BLK/plain/DSCF7861 2nobg.webp";
import wheel69 from "../assets/wheels/2024 02 16 - photo rota/RB/RB-X 17_17X9.5_-19_4X114.3_73_RL GUNMETALLIC/plain/DSCF7841 2nobg.webp";
import wheel70 from "../assets/wheels/2024 02 16 - photo rota/RB/RB-X 17_17X9.5_-19_4X114.3_73_RL HYP BLACK/plain/DSCF7848 2nobg.webp";
import wheel71 from "../assets/wheels/2024 02 16 - photo rota/RB/RB-X 17_17X9.5_-19_4X114.3_73_RL YMH BLK/plain/DSCF7874 1nobg.webp";

import wheel72 from "../assets/wheels/2024 02 16 - photo rota/RECCE/RECCE_17X7.5_40_4X108_63.35_HYPER BLACK/plain/DSCF7429nobg.webp";
import wheel73 from "../assets/wheels/2024 02 16 - photo rota/SHAKOTAN/SHAKOTAN_15X8_0_4X100_67.1_RF YMH BLACK/plain/DSCF7633nobg.webp";

import wheel74 from "../assets/wheels/2024 02 16 - photo rota/SLIP STREAM/SLIP STREAM_15X6.5_40_4X100_67.1_RF GUNMETALLIC/plain/DSCF7580nobg.webp";
import wheel75 from "../assets/wheels/2024 02 16 - photo rota/SLIP STREAM/SLIP STREAM_15X7_35_5X100_57.1_PLAIN SILVER/plain/DSCF7741 1nobg.webp";
import wheel76 from "../assets/wheels/2024 02 16 - photo rota/SLIP STREAM/SLIP STREAM_15X7_40_4X100_56.1_RF GUNMETALLIC/plain/DSCF7544nobg.webp";
import wheel77 from "../assets/wheels/2024 02 16 - photo rota/SLIP STREAM/SLIP STREAM_15X7_40_5X114.3_73_SATIN BLACK/plain/DSCF7567nobg.webp";
import wheel78 from "../assets/wheels/2024 02 16 - photo rota/SLIP STREAM/SLIPSTREAM R_18X9.5_40_5X120_64.1_MAG BLK/plain/DSCF8591nobg.webp";

import React, { useEffect, useState } from "react";
import ProductCard from "./ProductCard";
import { useNavigate } from "react-router-dom";
import Axios from "axios";
import { toast } from "react-toastify";
import Loading from "./base/Loading";

const API_URL = process.env.REACT_APP_API_URL;

function SectionProduct({ curr }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [listWheel, setListWheel] = useState(
    []
    //   [
    //   {
    //     wheel_id: 1,
    //     wheel_name: "ATLAS 1",
    //     wheel_details: [
    //       {
    //         wheel_details_name: "ATLAS 1 17_17x8.5_4_5x139.7_106.1_ RL YMH BLK",
    //         wheel_image: wheel1,
    //       },
    //     ],
    //   },
    //   {
    //     wheel_id: 2,
    //     wheel_name: "CIRCUIT 8",
    //     wheel_details: [
    //       {
    //         wheel_details_name: "CIRCUIT 8_15x6.5_38_8x100x100_67.1_BRONZE",
    //         wheel_image: wheel2,
    //       },
    //     ],
    //   },
    //   {
    //     wheel_id: 3,
    //     wheel_name: "CIRCUIT 10",
    //     wheel_details: [
    //       {
    //         wheel_details_name: "CIRCUIT 10_15X6.5_45_4X100_67.1_RF SP BRONZE",
    //         wheel_image: wheel3,
    //       },
    //     ],
    //   },
    //   {
    //     wheel_id: 4,
    //     wheel_name: "D2",
    //     wheel_details: [
    //       {
    //         wheel_details_name: "D2_16x7_40_5x114_73_RL CARBON FIBER",
    //         wheel_image: wheel4,
    //       },
    //     ],
    //   },
    //   {
    //     wheel_id: 5,
    //     wheel_name: "DPT",
    //     wheel_details: [
    //       {
    //         wheel_details_name: "DPT_17x8_48_10x114x100_73_HYPER BLACK",
    //         wheel_image: wheel5,
    //       },
    //     ],
    //   },
    //   {
    //     wheel_id: 6,
    //     wheel_name: "FIGHTER",
    //     wheel_details: [
    //       {
    //         wheel_details_name:
    //           "FIGHTER 10H 1670_16X7_40_10X114.3X100_73_HYPER SILVER IMP1",
    //         wheel_image: wheel6,
    //       },
    //     ],
    //   },
    //   {
    //     wheel_id: 7,
    //     wheel_name: "FIVE STAR OFF",
    //     wheel_details: [
    //       {
    //         wheel_details_name: "FIVE STAR OFF_16x8_10_6x139.7_110_BRONZE",
    //         wheel_image: wheel7,
    //       },
    //     ],
    //   },
    //   {
    //     wheel_id: 8,
    //     wheel_name: "G-FORCE",
    //     wheel_details: [
    //       {
    //         wheel_details_name: "G-FORCE_17x9_42_5x100_73_HYPER BLACK",
    //         wheel_image: wheel8,
    //       },
    //     ],
    //   },
    //   {
    //     wheel_id: 9,
    //     wheel_name: "GRID CLASSIC",
    //     wheel_details: [
    //       {
    //         wheel_details_name: "GRID CLASSIC_15x7_0_4x100_67.1_RF SP BRONZE",
    //         wheel_image: wheel9,
    //       },
    //       {
    //         wheel_details_name: "GRID CLASSIC_15x7_20_4x100_67.1_BRONZE",
    //         wheel_image: wheel10,
    //       },
    //       {
    //         wheel_details_name: "GRID CLASSIC_15x7_20_4x100_67.1_WHITE",
    //         wheel_image: wheel11,
    //       },
    //       {
    //         wheel_details_name: "GRID CLASSIC_15x8_0_4x100_67.1_RF P SILVER",
    //         wheel_image: wheel12,
    //       },
    //       {
    //         wheel_details_name:
    //           "GRID CLASSIC_15x8_0_5x114_73_FLAT GUN YMH BLK LIP",
    //         wheel_image: wheel13,
    //       },
    //       {
    //         wheel_details_name: "GRID CLASSIC_15x9_-15_4x114_73_RF SP BRONZE",
    //         wheel_image: wheel14,
    //       },
    //       {
    //         wheel_details_name: "GRID CLASSIC_16x8_20_4x100_67.1_SATIN BLACK",
    //         wheel_image: wheel15,
    //       },
    //       {
    //         wheel_details_name: "GRID CLASSIC_16x8_20_5x114_73_WHITE",
    //         wheel_image: wheel16,
    //       },
    //     ],
    //   },
    //   {
    //     wheel_id: 10,
    //     wheel_name: "GRID CONCAVE",
    //     wheel_details: [
    //       {
    //         wheel_details_name: "GRID CONCAVE_15x8_20_5x114_73_HYPER BLACK",
    //         wheel_image: wheel17,
    //       },
    //       {
    //         wheel_details_name: "GRID CONCAVE_15x8_20_5x114_73_WHITE",
    //         wheel_image: wheel18,
    //       },
    //       {
    //         wheel_details_name: "GRID CONCAVE_15X8_20_5X114.3_73_PLAIN SILVER",
    //         wheel_image: wheel19,
    //       },
    //       {
    //         wheel_details_name: "GRID CONCAVE_15X8_20_5X114.3_73_RF P SILVER",
    //         wheel_image: wheel20,
    //       },
    //       {
    //         wheel_details_name: "GRID CONCAVE_15X8_20_5X114.3_73_RF SP BRONZE",
    //         wheel_image: wheel21,
    //       },
    //       {
    //         wheel_details_name: "GRID CONCAVE_15x9_36_4x100_67.1_HYPER BLACK",
    //         wheel_image: wheel22,
    //       },
    //       {
    //         wheel_details_name: "GRID CONCAVE_15x9_36_4x100_67.1_SPEED BRONZE",
    //         wheel_image: wheel23,
    //       },
    //       {
    //         wheel_details_name: "GRID CONCAVE_16X8_20_5X114.3_73_RF P SILVER",
    //         wheel_image: wheel24,
    //       },
    //       {
    //         wheel_details_name: "GRID CONCAVE_16X8_20_5X114.3_73_SATIN BLACK",
    //         wheel_image: wheel25,
    //       },
    //       {
    //         wheel_details_name: "GRID CONCAVE_16X8_20_5X114.3_73_WHITE",
    //         wheel_image: wheel26,
    //       },
    //     ],
    //   },
    //   {
    //     wheel_id: 11,
    //     wheel_name: "GRID RACING",
    //     wheel_details: [
    //       {
    //         wheel_details_name: "GRID RACING_15x6.5_38_4x100_67.1_SPORT BRONZE",
    //         wheel_image: wheel27,
    //       },
    //       {
    //         wheel_details_name: "GRID RACING_15x7_38_4x100_67.1_PCWH_WHITE",
    //         wheel_image: wheel28,
    //       },
    //       {
    //         wheel_details_name: "GRID RACING_16x7_42_4x108_63.35_SATIN BLACK",
    //         wheel_image: wheel29,
    //       },
    //       {
    //         wheel_details_name:
    //           "GRID RACING_17x7.5_45_5x114_73_PCSB_RF SP BRONZE",
    //         wheel_image: wheel30,
    //       },
    //       {
    //         wheel_details_name: "GRID RACING_17x8_40_4x108_73_HYPER BLACK",
    //         wheel_image: wheel31,
    //       },
    //       {
    //         wheel_details_name: "GRID RACING_17x8_40_4x108_73_WHITE",
    //         wheel_image: wheel32,
    //       },
    //       {
    //         wheel_details_name: "GRID RACING_17x8_44_5x100_73_PLAIN GOLD",
    //         wheel_image: wheel33,
    //       },
    //       {
    //         wheel_details_name: "GRID RACING_17x9_42_5x114_73_SATIN BLACK",
    //         wheel_image: wheel34,
    //       },
    //       {
    //         wheel_details_name: "GRID RACING_18x9.5_20_5x114_73_PLAIN GOLD",
    //         wheel_image: wheel35,
    //       },
    //       {
    //         wheel_details_name: "GRID RACING_18x10_30_5x100_73_FLAT BLACK",
    //         wheel_image: wheel36,
    //       },
    //       {
    //         wheel_details_name: "GRID RACING_19x8.5_44_5x114_73_CHAMELEON",
    //         wheel_image: wheel37,
    //       },
    //       {
    //         wheel_details_name: "GRID RACING_19x8.5_44_5x114_73_SPEED BRONZE",
    //         wheel_image: wheel38,
    //       },
    //       {
    //         wheel_details_name: "GRID RACING_19x9.5_38_5x114_73_TITANIUM CHROME",
    //         wheel_image: wheel39,
    //       },
    //       {
    //         wheel_details_name: "GRID RACING_19X9.5_45_5X120_64.1_COSMIC BLUE",
    //         wheel_image: wheel40,
    //       },
    //       {
    //         wheel_details_name: "GRID RACING_19X9.5_45_5X120_64.1_RF SP BRONZE",
    //         wheel_image: wheel41,
    //       },
    //       {
    //         wheel_details_name: "GRID RACING_19x9.5_45_5X120_64.1_SATIN BLACK",
    //         wheel_image: wheel42,
    //       },
    //       {
    //         wheel_details_name: "GRID RACING_19x10.5_15_5x114_73_FLAT BLACK",
    //         wheel_image: wheel43,
    //       },
    //     ],
    //   },
    //   {
    //     wheel_id: 12,
    //     wheel_name: "HB10",
    //     wheel_details: [
    //       {
    //         wheel_details_name: "HB10_15x7_35_4x100_56.1_RL GUNMETALLIC",
    //         wheel_image: wheel44,
    //       },
    //     ],
    //   },
    //   {
    //     wheel_id: 13,
    //     wheel_name: "HUNTER",
    //     wheel_details: [
    //       {
    //         wheel_details_name: "HUNTER_15x7_35_4x100_67.1_SPORT BRONZE",
    //         wheel_image: wheel45,
    //       },
    //     ],
    //   },
    //   {
    //     wheel_id: 14,
    //     wheel_name: "J-SPL",
    //     wheel_details: [
    //       {
    //         wheel_details_name: "J-SPL_15x6.5_37_4x100_67.1_RL CARBON FIBER",
    //         wheel_image: wheel46,
    //       },
    //     ],
    //   },
    //   {
    //     wheel_id: 15,
    //     wheel_name: "KB-R",
    //     wheel_details: [
    //       {
    //         wheel_details_name: "KBR_18X9.5_38_5X100_73_WHITE",
    //         wheel_image: wheel47,
    //       },
    //       {
    //         wheel_details_name: "KBR_18x9.5_38_5x114_73_SATIN BLACK",
    //         wheel_image: wheel48,
    //       },
    //       {
    //         wheel_details_name: "KBR_18X9.5_38_5X114.3_73_PLAIN GOLD",
    //         wheel_image: wheel49,
    //       },
    //     ],
    //   },
    //   {
    //     wheel_id: 16,
    //     wheel_name: "KENSEI",
    //     wheel_details: [
    //       {
    //         wheel_details_name: "KENSEI_15x9_-15_4x114_73_RL HYP BLK",
    //         wheel_image: wheel50,
    //       },
    //     ],
    //   },
    //   {
    //     wheel_id: 17,
    //     wheel_name: "MXR",
    //     wheel_details: [
    //       {
    //         wheel_details_name: "MXR-R2 18_18x11_20_5x114_73_RL HYP BLK",
    //         wheel_image: wheel51,
    //       },
    //     ],
    //   },
    //   {
    //     wheel_id: 18,
    //     wheel_name: "OS MESH",
    //     wheel_details: [
    //       {
    //         wheel_details_name: "OS MESH 15_15x8_20_4x100_67.1_RL STEEL GRAY",
    //         wheel_image: wheel52,
    //       },
    //     ],
    //   },
    //   {
    //     wheel_id: 19,
    //     wheel_name: "PSD",
    //     wheel_details: [
    //       {
    //         wheel_details_name: "PSD 17_17x7.5_35_5x130_71.6_FSL FSB FBI",
    //         wheel_image: wheel53,
    //       },
    //       {
    //         wheel_details_name: "PSD 17_17x7.5_35_5x130_71.6_RL YMH BLACK",
    //         wheel_image: wheel54,
    //       },
    //       {
    //         wheel_details_name: "PSD 17_17x7.5_35_5x130_71.6_FSL FSB FBI",
    //         wheel_image: wheel55,
    //       },
    //       {
    //         wheel_details_name: "PSD 17_17x7.5_35_5x130_71.6_FSL FSB FBI",
    //         wheel_image: wheel56,
    //       },
    //       {
    //         wheel_details_name: "PSD 17_17x7.5_35_5x130_71.6_FSL FSB FBI",
    //         wheel_image: wheel57,
    //       },
    //     ],
    //   },
    //   {
    //     wheel_id: 20,
    //     wheel_name: "R-SPEC",
    //     wheel_details: [
    //       {
    //         wheel_details_name: "R-SPEC 16_16x7_45_4x100_67.1_SATIN BLACK",
    //         wheel_image: wheel58,
    //       },
    //     ],
    //   },
    //   {
    //     wheel_id: 21,
    //     wheel_name: "RB",
    //     wheel_details: [
    //       {
    //         wheel_details_name: "RB 15_15x7_4_4x114_73_RL P SILVER",
    //         wheel_image: wheel59,
    //       },
    //       {
    //         wheel_details_name: "RB 15_15X7_4_4X114.3_73_SATIN BLACK",
    //         wheel_image: wheel60,
    //       },
    //       {
    //         wheel_details_name: "RB 15_15x7_12_4x114_73_RL P SILVER",
    //         wheel_image: wheel61,
    //       },
    //       {
    //         wheel_details_name: "RB 16_16X7_40_4X100_56.1_RL GUNMETALLIC",
    //         wheel_image: wheel62,
    //       },
    //       {
    //         wheel_details_name: "RB 17_17X7.5_45_4X100_56.1_RL P SILVER",
    //         wheel_image: wheel63,
    //       },
    //       {
    //         wheel_details_name: "RB REAR 17_17X8.5_4_4X114.3_73_RL HYP BLACK",
    //         wheel_image: wheel64,
    //       },
    //       {
    //         wheel_details_name: "RB_13x8_4_4x114_73_RL P SILVER",
    //         wheel_image: wheel65,
    //       },
    //       {
    //         wheel_details_name: "RB-X 17_17X9_-13_4X114.3_73_RL GUNMETALLIC",
    //         wheel_image: wheel66,
    //       },
    //       {
    //         wheel_details_name: "RB-X 17_17X9_-13_4X114.3_73_RL HYP BLACK",
    //         wheel_image: wheel67,
    //       },
    //       {
    //         wheel_details_name: "RB-X 17_17X9_-13_4X114.3_73_RL YMH BLK",
    //         wheel_image: wheel68,
    //       },
    //       {
    //         wheel_details_name: "RB-X 17_17X9.5_-19_4X114.3_73_RL GUNMETALLIC",
    //         wheel_image: wheel69,
    //       },
    //       {
    //         wheel_details_name: "RB-X 17_17X9.5_-19_4X114.3_73_RL HYP BLACK",
    //         wheel_image: wheel70,
    //       },
    //       {
    //         wheel_details_name: "RB-X 17_17X9_-13_4X114.3_73_RL YMH BLK",
    //         wheel_image: wheel71,
    //       },
    //     ],
    //   },
    //   {
    //     wheel_id: 22,
    //     wheel_name: "RECCE",
    //     wheel_details: [
    //       {
    //         wheel_details_name: "RECCE_17X7.5_40_4X108_63.35_HYPER BLACK",
    //         wheel_image: wheel72,
    //       },
    //     ],
    //   },
    //   {
    //     wheel_id: 23,
    //     wheel_name: "SHAKOTAN",
    //     wheel_details: [
    //       {
    //         wheel_details_name: "SHAKOTAN_15X8_0_4X100_67.1_RF YMH BLACK",
    //         wheel_image: wheel73,
    //       },
    //     ],
    //   },
    //   {
    //     wheel_id: 24,
    //     wheel_name: "SLIP STREAM",
    //     wheel_details: [
    //       {
    //         wheel_details_name: "SLIP STREAM_15X6.5_40_4X100_67.1_RF GUNMETALLIC",
    //         wheel_image: wheel74,
    //       },
    //       {
    //         wheel_details_name: "SLIP STREAM_15X7_35_5X100_57.1_PLAIN SILVER",
    //         wheel_image: wheel75,
    //       },
    //       {
    //         wheel_details_name: "SLIP STREAM_15X7_40_4X100_56.1_RF GUNMETALLIC",
    //         wheel_image: wheel76,
    //       },
    //       {
    //         wheel_details_name: "SLIP STREAM_15X7_40_5X114.3_73_SATIN BLACK",
    //         wheel_image: wheel77,
    //       },
    //       {
    //         wheel_details_name: "SLIPSTREAM R_18X9.5_40_5X120_64.1_MAG BLK",
    //         wheel_image: wheel78,
    //       },
    //     ],
    //   },
    // ]
  );

  const [activeWheels, setActiveWheels] = useState([]);

  const getDataAllWheels = async () => {};

  useEffect(() => {
    
    readProductList();
  }, []);

  const readProductList = () => {
    setLoading(true)
    Axios.get(API_URL + "/wheel")
      .then((res) => {
        if (res.data) {
          setListWheel(res.data);
          const printWheel = [];

          for (let i = 0; i < res.data.length; i++) {
            if (curr == res.data[i].wheel_id) {
              continue;
            } else {
              if (res.data[i].wheel_details[0]) {
                printWheel.push({
                  wheel_id: res.data[i].wheel_id,
                  wheel_details_name: res.data[i].wheel_name,
                  wheel_image: res.data[i].wheel_details[0].wheel_details_image,
                });
              }
            }
            if (printWheel.length > 9) break;
          }
          console.log(printWheel);
          setActiveWheels(printWheel);
        } else {
          toast.error("Failed to Get Data", {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            progress: undefined,
            theme: "dark",
          });
        }
        setLoading(false)
      })
      .catch((error) => {
        toast.error("Failed to Get Data", {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false)
      });
  };

  const gotoWheelDetails = (item) => {
    localStorage.setItem("selectedWheel", JSON.stringify(item));
    navigate(`/wheels/${item.wheel_id}`);
    window.location.reload();
  };

  const generateProductList = () => {
    if (activeWheels) {
      return activeWheels.map((item, index) => {
        if (index < 10)
          return (
            <div key={index} onClick={() => gotoWheelDetails(item)}>
              <ProductCard
                productImage={item.wheel_image}
                productName={item.wheel_details_name}
              ></ProductCard>
            </div>
          );
      });
    }
  };
  return (
    <>
      {loading ? (
        <div className="w-48 h-48 mx-auto my-12">
            <Loading>

            </Loading>
        </div>
      ) : (
        <div className="flex gap-2 sm:gap-4 justify-center md:justify-between flex-wrap mb-8">
          {generateProductList()}
        </div>
      )}
      
    </>
  );
}
export default SectionProduct;
